module.exports = __webpack_public_path__ + "img/play-button.99e506d9.png";